module.exports = __webpack_public_path__ + "img/top_logo_text.2d8e32fc.png";